module.exports = __webpack_public_path__ + "img/pricing-Illustration.0c072da6.svg";